import { render } from "./AddressProgramOrders.vue?vue&type=template&id=1ee9534a"
import script from "./AddressProgramOrders.vue?vue&type=script&lang=js"
export * from "./AddressProgramOrders.vue?vue&type=script&lang=js"

import "./AddressProgramOrders.vue?vue&type=style&index=0&id=1ee9534a&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__